<script>
	import { Pie } from 'vue-chartjs'
	export default {
	  extends: Pie,
	  data () {
	  	return {
	  		chart_options: {

                responsive: true,
                maintainAspectRatio: false
	  		},
	  		datas: {}
	  	}
	  },
	  mounted () {
	  	this.fetchDatas();
	    // Overwriting base render method with actual data.
	  },
	  methods: {
	  	changeUrl(newUrl){
            this.url = newUrl;
            this.fetchDatas();
        },
	  	fetchDatas() {

			var url = this.url;
			if (this.stringParameters != null && this.stringParameters != "") {
				url += "?" + this.stringParameters;
			}
			  
	  		axios.get(url).then(response => {
		      	this.datas = response.data;
		    	this.renderChart(this.datas, this.chart_options);
		      });

		 }
	  },
	  props: {
	  	url: {
	  		type: String,
	  		requred: true
	  	},
		stringParameters: {
			type: String,
			required: false
		},
	  }

	}
</script>
